import { render, staticRenderFns } from "./bottomBox.vue?vue&type=template&id=0815dd22&scoped=true&"
import script from "./bottomBox.vue?vue&type=script&lang=js&"
export * from "./bottomBox.vue?vue&type=script&lang=js&"
import style0 from "./bottomBox.vue?vue&type=style&index=0&id=0815dd22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0815dd22",
  null
  
)

export default component.exports